import React, { useState } from 'react';
import { Grid, Typography, Box, Button, Paper } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SaveButton from 'components/buttonsComponent/SaveButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';
import { color, fontFamily, fontWeight, height, width } from '../../../node_modules/@mui/system/index';
import { FaUpload } from "react-icons/fa";
import UserIdButton from 'components/buttonsComponent/UserIdButton';

const UploadPostReviewGapForm = ({ onPrevious, onNext }) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSubmit = () => {
    console.log("Submitting form with file:", selectedFile);
    onNext && onNext();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          className="standards-header"
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
            [theme => theme.breakpoints.down('sm')]: {
              justifyContent: 'center',
              flexDirection: 'column',
              alignItems: 'stretch',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              alignItems: 'center',
            }}
          >

            <SaveButton
            // onClick={handleSave}
            >
              Save
            </SaveButton>
            <UserIdButton />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          className="my-4"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
            gap: 3,
            flexWrap: 'wrap',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              top: '27px',
              left: '218px',
              width: 268,
              height: 311,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              border: '1px dashed #e0e0e0',
              borderRadius: '13px',
              backgroundColor: '#fff',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 3,
              }}
            >
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  borderRadius: '50%',
                }}
              >
                <FaUpload style={{ fontSize: 40, color: '#4b8048', width: '46px', height: '55px' }} />
              </Box>

              <Typography variant="h6" component="h2" style={{ fontWeight: 'bold', mb: 1, color: '#02462E', fontFamily: 'DM Sans', fontSize: '20px', lineHeight: '32px' }}>
                Upload Evidence
              </Typography>

              <Box style={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3, fontFamily: 'DM Sans', fontWeight: 400, color: '#76C0DB' }}>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  Attach reports, audit, and other compliance documents
                </Typography>
              </Box>
            </Box>

            <input
              accept="image/png,image/jpeg,image/gif"
              style={{ display: 'none' }}
              id="upload-file-button"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="upload-file-button">
              <Button
                variant="outlined"
                component="span"
                sx={{
                  borderColor: '#e0e0e0',
                  color: '#555',
                  '&:hover': {
                    borderColor: '#4b8048',
                    backgroundColor: 'rgba(75, 128, 72, 0.04)',
                  },
                  mb: 3,
                }}
              >
                Browse Files
              </Button>
            </label>

            {selectedFile && (
              <Typography variant="body2">Selected: {selectedFile.name}</Typography>
            )}
          </Paper>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: '400px',
              gap: 1,
              my: 'auto',
            }}
          >
            <Typography
              variant="h5"
              component="h1"
              sx={{
                fontWeight: 800,
                fontFamily: 'DM Sans',
                fontSize: '24px',
                lineHeight: '32px',
                color: '#02462E',
                textAlign: 'center',
                marginBottom: '8px',
              }}
            >
              Upload Post Review Gap Form
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#A3AED0',
                fontFamily: 'DM Sans',
                fontSize: '16px',
                lineHeight: '24px',
                textAlign: 'center',
                fontWeight: 400,
              }}
            >
              Please submit the completed Gap Form along with responses to the relevant queries and the required data
            </Typography>
            <SaveButton
              variant="contained"
              onClick={handleSubmit}
              name="Submit Gap Form & Next" icon={null}
              sx={{
                backgroundColor: '#02462E',
                color: '#fff',
                width: '300px',
                height: '50px',
                borderRadius: '8px',
                textTransform: 'none',
                fontFamily: 'DM Sans',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '20px',
                marginTop: '16px',
                '&:hover': {
                  backgroundColor: '#023d28',
                },
              }}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default UploadPostReviewGapForm;